export default __webpack_public_path__ + "static/media/RUG-MIM.0e5a06b9.svg";